import OrderDTO from "@/dto/order/OrderDTO";
import React from "react";
import { cancelOrdersBySupplier } from "@/services/api/dropShipping/order";
import { confirm } from "@/utils";
import { message, Modal } from "antd";
import moment from "moment";
import { useModalStore } from "@/hooks/Modal/hooks";
import HoldOrderModal from "../../../dialogs/HoldOrderDialog/HoldOrderModal";

const useCancelDropshippingOrdersClick = (onRefresh) => {
    const modalStore = useModalStore();

    async function cancelDropshippingOrders(orders: OrderDTO[]) {
        const now = moment().unix();

        const unsupportedOrders = orders.filter((order) => {
            // 如果有发货时间 并且超过30天的订单才支持取消
            if (order.shippingTime) {
                const maxShippingLimitTime = moment(order.shippingTime).add(moment.duration(30, "days")).unix();

                if (now < maxShippingLimitTime) {
                    return true;
                }
            }

            // 否则判断下单时间超过30天的订单
            const maxLimitTime = moment(order.orderTime).add(moment.duration(30, "days")).unix();

            if (now < maxLimitTime) {
                return true;
            }

            return false;
        });

        if (unsupportedOrders?.length) {
            const instance = Modal.error({
                title: "有不支持取消的订单，请重新选择",
                content:
                    "下单时间超过30天的订单或者发货时间超过30天的订单才支持取消，为了避免误操作订单,  可以先把订单挂起，等待30天后再取消该订单",
                okCancel: true,
                cancelText: "关闭",
                okText: "挂起订单",
                onOk() {
                    modalStore.openModal(HoldOrderModal, {
                        onSuccess: onRefresh,
                        orders: unsupportedOrders,
                    });

                    instance.destroy();
                },
            });

            return;
        }

        try {
            await confirm("订单取消后会进入已取消订单列表，不能再操作发货，也不会再计入对账单，确认取消订单吗？");

            const params = {
                supplierOrderIds: orders.map((order) => order.id),
                supplierShopId: orders[0].shopId,
            };

            message.open({
                content: "取消订单中...",
                duration: 0,
                type: "loading",
                key: "cancelOrderBySupplier",
            });

            await cancelOrdersBySupplier(params);

            message.success("取消成功");

            onRefresh?.();
        } finally {
            message.destroy("cancelOrderBySupplier");
        }
    }

    return cancelDropshippingOrders;
};

export default useCancelDropshippingOrdersClick;
